/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { Schema, stringEnum } from '../schema';

/**
 * Enum for ContentType2Enum
 */
export enum ContentType2Enum {
  EnumApplicationjson = 'application/json',
}

/**
 * Schema for ContentType2Enum
 */
export const contentType2EnumSchema: Schema<ContentType2Enum> = stringEnum(ContentType2Enum);
